import { useQuery, useQueryClient } from "@sveltestack/svelte-query"
import { derived } from "svelte/store"

const ENDPOINT = "/api/license"

export function useLicenseData(options) {
  const queryResult = useQuery(ENDPOINT, options)

  return derived(queryResult, result => {
    return result.data
  })
}

export function useLicenseDataQuery() {
  return useQuery(ENDPOINT)
}

/**
 *
 * @returns {{invalidateLicenseData: () => Promise<void>}}
 */
export function useInvalidateLicenseData() {
  const queryClient = useQueryClient()

  return {
    invalidateLicenseData: () => queryClient.invalidateQueries(ENDPOINT)
  }
}
